export default "__VITE_ASSET__a0925146__"